import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatDateStr(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString('de-DE', { 
    weekday: 'long',
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric' 
  });
}

function CourseGroup({ name, dates }) {
  return (
    <div className="border border-gray-200 rounded-lg p-6">
      <h4 className="text-lg font-semibold text-gray-800 mb-4">{name}</h4>
      <div className="space-y-3">
        {dates.map((d, i) => (
          <div key={i} className="flex justify-between text-gray-700">
            <span>{formatDateStr(d.date)}</span>
            <span className="text-gray-500">{d.time_start} - {d.time_end} Uhr</span>
          </div>
        ))}
      </div>
      <p className="mt-4 text-sm text-green-600 font-medium">Anmeldung offen</p>
    </div>
  );
}

export default function CoursesPage() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/courses/active`)
      .then(res => setCourses(res.data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  const course = courses[0];
  
  let group1 = [];
  let group2 = [];
  
  if (course && course.dates) {
    const mid = Math.ceil(course.dates.length / 2);
    group1 = course.dates.slice(0, mid);
    group2 = course.dates.slice(mid);
  }

  return (
    <div className="bg-white" data-testid="courses-page">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-normal text-gray-800 text-center mb-8">Kursangebote</h1>

        {course ? (
          <div className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">{course.title}</h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">{course.description}</p>
            
            <div className="bg-gray-50 p-6 rounded-lg mb-6">
              <p className="mb-3"><strong>Zielgruppe:</strong> {course.target_audience}</p>
              <p className="mb-3"><strong>Methode:</strong> {course.method}</p>
              <p><strong>Kosten:</strong> {course.price}</p>
            </div>
            
            <p className="text-sm text-gray-500 mb-8">{course.price_info}</p>

            <hr className="my-8 border-gray-300" />

            <h3 className="text-xl font-semibold text-gray-800 mb-6">Termine 2026</h3>
            <p className="text-gray-500 mb-6">Immer mittwochs von 9:00 bis 10:50 Uhr</p>

            <div className="grid md:grid-cols-2 gap-8">
              <CourseGroup name="Gruppe 1" dates={group1} />
              <CourseGroup name="Gruppe 2" dates={group2} />
            </div>
          </div>
        ) : (
          <div className="text-center py-12 text-gray-500">
            Derzeit keine Kurse verfügbar.
          </div>
        )}

        <div className="mt-12 text-center border-t pt-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">Interesse an einem Kurs?</h3>
          <p className="text-gray-500 mb-4">Kontaktieren Sie mich gerne für weitere Informationen oder zur Anmeldung.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="tel:+4915751336474" className="text-blue-500 hover:underline">
              Tel: +49 157 51336474
            </a>
            <span className="hidden sm:inline text-gray-400">|</span>
            <a href="mailto:Psychotherapie-Praxis-langer@gmx.de" className="text-blue-500 hover:underline">
              E-Mail senden
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
